import React from "react";
import { LoadioStoreHomeSectionListTemplate } from "themes/administration/loadio/pages";
import { LoadioStoreHomeSectionListViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioStoreHomeSectionListViewStore(rootStore, componentProps),
    "loadioStoreHomeSectionListViewStore"
)
class LoadioStoreHomeSectionList extends React.Component {
    render() {
        return <LoadioStoreHomeSectionListTemplate {...this.props} />;
    }
}

export default LoadioStoreHomeSectionList;
